import {
  LOGIN,
  LOGOUT,
  GET_ALL_COMPETENCY,
  UPDATE_USER_PERSONAL_INFO,
  // GET_STUDENT_COUNT,
  // GET_TEACHER_COUNT,
  GET_DASHBOARD_COUNT
} from "../types";
import {
  setLocalStorage,
  getLocalStorage,
  clearLocalStorage,
} from "../../helpers/Utils";

const INITIAL_STATE = {
  userData: getLocalStorage("userInfo") || {},
  competencyData: [],
  dashboardData: getLocalStorage("dashboardData") || {},
  studentCount: 0,
  teacherCount: 0,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case LOGIN:
      if (action.payload && action.payload.result) {
        const userInfo = action.payload.result;
        setLocalStorage("userInfo", action.payload.result);
        state.userData = userInfo;
      }
      return { ...state };

    case LOGOUT:
      state.userData = {};
      state.competencyData = [];
      clearLocalStorage();
      return { ...state };

    case GET_ALL_COMPETENCY:
      if (action.payload && action.payload.result) {
        state.competencyData = action.payload.result;
      }
      return { ...state };

    case UPDATE_USER_PERSONAL_INFO:
      if (action.payload) {
        const object = action.payload;
        let userInfo = getLocalStorage("userInfo");

        for (const key in object) {
          if (object.hasOwnProperty(key)) {
            const element = object[key];
            userInfo[key] = element;
            state[key] = element;
          }
        }

        state.userData = userInfo;
        setLocalStorage("userInfo", userInfo);
      }
      return { ...state };
    
    // case GET_STUDENT_COUNT:
    //   if (action.payload) {
    //     state.studentCount = action.payload;
    //   }
    //   return { ...state };
    
    // case GET_TEACHER_COUNT:
    //   if (action.payload) {
    //     state.studentCount = action.payload;
    //   }
    //   return { ...state };
    
    case GET_DASHBOARD_COUNT:
      if (action.payload && action.payload.result) {
        const dashboardData = action.payload.result;
        setLocalStorage("dashboardData", dashboardData);
        state.dashboardData = dashboardData;
      }
      return { ...state };

    default:
      return state;
  }
};
